



























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {CountryParams} from "../../params";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {debounce} from "lodash";
import {CountryStore} from "@/modules/regionsv2/country/store";
import CountryForm from "@/modules/regionsv2/country/Form/index.vue";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: 'CountrySearch',
    components: {CountryForm, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    params = new CountryParams();
    CommonStatus = CommonStatus;
    visibleForm = false;

    @Watch("params", { immediate: true, deep: true })
    onChangeParams(val) {
        this.handleChangeParams(val);
    }

    handleChangeParams = debounce((val) => {
        CountryStore.paramsChangeV2({ ...val, page: 1 });
    }, 300)

    create() {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_CREATE_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        this.visibleForm = true;
    }
}
